/**
 * ServicePrintMenu.js - P0-CORE: Menu fixo de impressão para serviços
 * 
 * Disponível em todas as abas do serviço.
 * Permite emitir:
 * - Guia de Receção
 * - Guia de Entrega
 * - Cotação (se existir)
 * - Comprovativo de Pagamento
 * 
 * P0-2 FIX: Usa download autenticado com Authorization header
 */

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { 
  Printer, Loader2
} from 'lucide-react';
import ServicePrintDialog from '@/components/ServicePrintDialog';

export default function ServicePrintMenu({ 
  service, 
  disabled = false,
  showLabels = false 
}) {
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!service) return null;

  if (showLabels) {
    return (
      <>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setDialogOpen(true)}
          disabled={disabled}
          data-testid="service-print-open-dialog-button"
        >
          <Printer className="h-4 w-4 mr-1" />
          Imprimir documentos
        </Button>

        <ServicePrintDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          service={service}
        />
      </>
    );
  }

  return (
    <>
      <Button 
        variant="outline" 
        size="sm" 
        className="h-7 px-2"
        disabled={disabled}
        onClick={() => setDialogOpen(true)}
        data-testid="service-print-open-dialog-button"
      >
        {disabled ? (
          <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />
        ) : (
          <Printer className="h-3.5 w-3.5 mr-1" />
        )}
        Imprimir
      </Button>

      <ServicePrintDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        service={service}
      />
    </>
  );
}
